import { render, staticRenderFns } from "./AgendaTelefonica.vue?vue&type=template&id=4d1f45e8&"
import script from "./AgendaTelefonica.vue?vue&type=script&lang=js&"
export * from "./AgendaTelefonica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports